import { normalize } from 'normalizr';

import { part as partSchema } from './schema';
import { RECEIVE, RECEIVE_PART_MODEL } from './types';

export const receivePart = ({ part }) => ({
  type: RECEIVE,
  payload: {
    ...normalize(part, partSchema),
    data: { part },
  },
});

export const receivePartModel = (partId, partModel) => ({
  type: RECEIVE_PART_MODEL,
  payload: {
    entities: {
      partModels: {
        [partId]: partModel,
      },
    },
  },
});
